import React from 'react';
import { motion } from 'framer-motion';
import { Clock, User, Calendar } from 'lucide-react';

export const ArticleHero = ({ eyebrow, title, intro, author, date, readingTime, heroImage, heroImageAlt }) => (
  <section className="relative bg-primary-bg text-primary-foreground overflow-hidden" data-testid="article-hero">
    <div className="absolute inset-0 z-0">
      {heroImage && (
        <img src={heroImage} alt={heroImageAlt || title} className="w-full h-full object-cover opacity-20" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-primary-bg via-primary-bg/90 to-primary-bg/70" />
    </div>

    <div className="relative z-10 container-portico py-16 md:py-24 lg:py-28">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl"
      >
        {eyebrow && (
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-foreground/70 mb-4 border border-primary-foreground/20 rounded-full px-3 py-1">
            {eyebrow}
          </span>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6" data-testid="article-title">
          {title}
        </h1>
        {intro && (
          <p className="text-base md:text-lg text-primary-foreground/80 leading-relaxed mb-8 max-w-2xl">
            {intro}
          </p>
        )}
        <div className="flex flex-wrap items-center gap-4 text-sm text-primary-foreground/60">
          {author && (
            <span className="flex items-center gap-1.5">
              <User className="w-3.5 h-3.5" /> {author}
            </span>
          )}
          {date && (
            <span className="flex items-center gap-1.5">
              <Calendar className="w-3.5 h-3.5" /> {new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </span>
          )}
          {readingTime && (
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5" /> {readingTime}
            </span>
          )}
        </div>
      </motion.div>
    </div>
  </section>
);
